// import ArmsRum from '@arms/rum-browser/dist/browser-sdk'
import { isProdFn, getEnvFn, defauleSpaMode, defaultSystemName } from './main.js'
import eventFilterData from './utils/eventFilterData'
import filtersExceptionArr from './utils/filtersException'
// arms阿里文档地址： https://help.aliyun.com/zh/arms/user-experience-monitoring/access-web-h5-applications?spm=a2c4g.11186623.0.0.112b4868wKe3vQ#dd234b77d0mx0

/**
 * 所有的资源请求、ajax都会经过这个函数加工一遍后上报给arams，
 * 默认arms的success的值是根据http的status的，可以在这个函数里根据我们公司的内部接口返回的code值来决定上报给arms的success的值是成功还是失败，同时把请求参数和接口返回值用上报上去
 **/
async function evaluateApi(options, response, error) {
  if (!options || !options.type || options.type != 'xmlhttprequest') {
    return null
  }
  const name = options && options.url
  let success = error ? 0 : 1
  let respText = response
  if (response && response instanceof Response) {
    // 当前为使用fetch请求的情况
    if (response.text) {
      respText = await response.text()
    }
  } else if (response && typeof response == 'string') {
    respText = response
  } else if (
    response &&
    Object.prototype.toString.call(response) == '[object Object]'
  ) {
    respText = JSON.stringify(response)
    if (response && response.code) {
      if (
        ![
          '200', // java基础
          '00000000', // 订单中台
          '1083'
        ].includes(String(response.code))
      ) {
        success = 0
      }
    }
  }
  // 返回的字段会覆盖默认内容，不返回的字段会依然使用SDK自定生成内容
  return {
    name,
    success,
    snapshots: JSON.stringify({
      params: options && options.data, // 请求入参
      response: respText.substring(0, 2000), // 返回值
      reqHeaders:
        options && options.headers ? JSON.stringify(options.headers) : null // 请求头
    })
  }
}
function loadJS(path) {
  var script = document.createElement('script')
  script.crossorigin = ''
  script.type = 'text/javascript'
  script.src = path
  document.getElementsByTagName('head')[0].appendChild(script)
  script.onload = function() {
    window.ArmsRum = window.RumSDK.default
  }
}

export default (opt = {}) => {
  if (!isProdFn() && !opt.exceptProdAlsoRun) {
    /**
     * 默认非生产环境不上报。可以减少不必要的计量收费。
     * exceptProdAlsoRun默认等于false。表示非生产环境不上报。为true表示非生产环境也上报，这通常可以在调试阶段时可以开启测试使用
     */
    return
  }

  if (!opt.pid || !opt.endpoint) {
    // 这个值pid、endpoint是阿里arms后台系统拿取的
    throw Error(
      '缺少生产环境时上报的pid和endpoint配置项,这是值是在阿里arms后台系统拿取的'
    )
  }

  if (!opt.appCode) {
    // 系统编号作为唯一标识，后期用作扩展功能时使用
    throw Error('缺少项目编号配置项：${appCode}')
  }
  const env = getEnvFn()
  let pidEndpoint = {}
  if (isProdFn()) {
    pidEndpoint = { pid: opt.pid, endpoint: opt.endpoint }
  } else {
    // 内部测试上报地址都用同一个，生产真实上报地址让用户自己传入
    pidEndpoint = {
      pid: opt.testPid ? opt.testPid : 'j7rkhvvh0g@3854950d21b4b07',
      endpoint: 'https://j7rkhvvh0g-default-cn.rum.aliyuncs.com'
    }
  }
  const sdkSrc = 'https://sdk.rum.aliyuncs.com/v2/browser-sdk.js '
  window.__rum || (window.__rum = {})
  const app = {}
  if (opt.appName) {
    app.name = opt.appName || defaultSystemName // 优化目的：由于阿里云的sls日志里默认没有传name，所以这里主动上报下。
  }
  window.__rum = {
    ...pidEndpoint,
    env,
    app,
    user: {
      name: opt.name,
      tag: opt.appCode
    },
    spaMode: opt.spaMode || defauleSpaMode, // 必填：是否spa单页面应用，是的话填写具体的值：hash、history、auto、false。地上铁移动端一段为hash, pc端为history， 请根据自己的项目实际填写。如果不是vue或者react之类的单页面，填写false
    // Collector是RUM SDK用于收集页面监控数据的最小单元。目前RUM SDK内置了api、static Resource等丰富的采集器。
    Collectors: {
      consoleError: false // 监听Console错误。
    },
    // 自定义解析API事件,该函数支持异步函数，返回Promise<IApiBaseAttr>
    evaluateApi: evaluateApi,
    whiteScreen: {
      detectionRules: [
        {
          target: '#app',
          test_when: ['LOAD', 'ERROR', 'ROUTE_CHANGE', 'LEAVE'],
          delay: 5000,
          tester: 'SCREENSHOT',
          configOptions: {
            colorRange: ['rgb(255, 255, 255)', 'rgb(0, 0, 0)'],
            threshold: 0.9
          }
        }
      ]
    },
    filters: {
      // 以下条件顺序执行，有一项满足就会被过滤
      // 过滤异常
      exception: [
        // 'Test error', // 以'Test error'开头的error.message
        // /^Script error\.?$/, // 正则表达式 匹配 error.message
        // 返回
        (msg) => {
          let filtersArr = filtersExceptionArr
          if (opt.filtersExceptionArr && Object.prototype.toString.call(opt.filtersExceptionArr) === '[object Array]' && opt.filtersExceptionArr.length) {
            filtersArr.push(...opt.filtersExceptionArr)
          }
          // 函数 匹配 error.message
          for (let i = 0; i < filtersArr.length; i++) {
            let exceptionStr = filtersArr[i]
            if (Object.prototype.toString.call(exceptionStr) === '[object String]' && msg.indexOf(filtersArr[i]) !== -1) {
              // true 表示过滤掉不上报
              return true
            }
          }
          return false
        }
      ]
    },
    beforeReport: data => {
      /**
       * 这里我尝试改成async异步函数后，虽然没有报错，但是明明return了出去数据，但是结果上报的接口那里看到数据时空对象。所以这里面还是不能写异步、
       *
       * 这里最好是把忽略上报的规则放到服务器，然后项目初始化时去读取忽略规则，然后客户端动态根据规则拦截，这样方便开发者随时增加和删除管理一些无意义的报错。
       * 不过上面说到这里不能写异步函数，那就只能请求发完后将值赋给window下的全局变量。然后每次执行时读取该变量的值，但这样就无法保证请求服务器返回前的错误也能被正确拦截。就是在请求拦截规则数据返回期间的报错走不了拦截了。不过感觉这个时间差基本可以忽略。而且还可以考虑请求后将规则存在本地localstoreage，这样即使请求还没有返回前可以始终保证本地数据中也有值，请求返回后不过是更新下数据罢了。
       * 不过考虑到第一期如果全系统加的话，获取接口的api可能需要全局加代理，增加了工作量和复杂度。所以暂时先不使用远端获取的方式。后期有强烈需求需要时再加。
       * 后续加时api获取规则时可以查看：import { eventFilterDataApi, getIgnoreRuleList } from './utils/eventFilterData'方法。这2个方法一个获取规则，一个根据规则返回过滤，其实已经逻辑已经写出来，只是没有做最后的上线。
       */
      // 上报前检查过滤不需要上报的数据。返回值为false则不上报
      return eventFilterData(data)
    },
    tracing: true,
  }
  // 使用示例：
  loadJS(sdkSrc)
}
// 上报自定义异常数据，必须包含name和message两个属性，否则无法上报。
/**
 * ArmsRUM.sendException({
    // 必选
    name: 'customErrorName',
    message: 'custom error message',
    // 可选
    file: 'custom exception filename',
    stack: 'custom exception error.stack',
    line: 1,
    column: 2
  });
 */
export const sendExceptionData = opt => {
  if (!window.ArmsRum) {
    return
  }
  window.ArmsRum.sendException({
    ...opt
  })
}
// 上报自定义数据，必须包含type和name两个属性，否则无法上报。属性的具体业务意义可参考下表，实际使用需要自行定义业务语义。
/**
   * ArmsRum.sendCustom({
      type: 'CustomEvnetType1',
      name: 'customEventName2',
      group: 'customEventGroup3',
      value: 111.11
    });
   */
export const sendCustomData = opt => {
  if (!window.ArmsRum) {
    return
  }
  window.ArmsRum.sendCustom({
    ...opt
  })
}

// 修改SDK配置。特别使用用户登录后，可以及时更新用户信息
/**
 * setArmsConf({
 *  user: {
 *    name: `${realname}_${phone}`
 *  }
 * })
 *
 */
export const setArmsConf = (opt = {}) => {
  if (!window.ArmsRum) {
    return
  }
  // 覆盖设置
  const config = window.ArmsRum.getConfig()
  window.ArmsRum.setConfig({
    ...config,
    ...opt
  })
}

// 上报自定义资源，必须包含name、type和duration三个属性，否则无法上报。
/**
      ArmsRum.sendResource({
      // 必选
      name: 'getListByPage',
      message: 'success',
      duration: 800,
      // 可选
      url: 'https://www.aliyun.com/data/getListByPage',
    });
   */
export const sendResource = opt => {
  if (!window.ArmsRum) {
    return
  }
  // 覆盖设置
  window.ArmsRum.sendResource({
    ...opt
  })
}



// WEBPACK FOOTER //
// ./src/m-common/lib/armsRum/index.js